import React from 'react';

function AboutLeft({ title, description, link }) {
  return (
    <div className="about-role-card glass-card">
      <div className="role-icon-wrapper">
        {title.toLowerCase().includes("web") ? "👨‍💻" : "✍️"}
      </div>
      <div className="role-info">
        <h3 className="about-sub-head">{title}</h3>
        <p className="about-details">
          {description}
          {link && (
            <a
              className="about-link-element"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Read my blogs &rarr;
            </a>
          )}
        </p>
      </div>
    </div>
  );
}

export default AboutLeft;
